import React from "react";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { STRINGS } from "../../strings";
import CustomModal from "../../../../components/Modals/CustomModal";
import { Button } from "../../../../components/Buttons";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import { GREY } from "../../../../utils/constants/colors";
import { fontWeight } from "../../../../utils/constants/UI";
import {
  ESP_PROVIDER_LABEL,
  isOAuthMailboxEsp,
} from "../../../../utils/constants";
import {
  handleGoogleAuth,
  handleMicrosoftAuthInitialize,
  handleZohoAuth,
} from "../../../../utils/helpers";

const useStyles = makeStyles({
  modalBody: { padding: "1rem 1.5rem" },
  content: { display: "flex", flexDirection: "column", gap: "0.5rem" },
  footer: { display: "flex", gap: "0.75rem", justifyContent: "flex-end" },
});

// Confirm before sending the user off to their provider's sign-in page. The
// click navigates the whole tab to an external host, so an accidental tap on
// the kebab menu should not do that silently.
const ReconnectModal = ({ open, setOpen, mailbox }) => {
  const classes = useStyles();

  const esp = Number(mailbox?.esp);
  const providerLabel = ESP_PROVIDER_LABEL?.[esp] || STRINGS.YOUR_EMAIL_PROVIDER;

  const startConnect = () => {
    // Resolve the provider explicitly. A catch-all default would start a Gmail
    // sign-in for a non-Gmail row, which is worse than doing nothing.
    if (esp === 5) {
      handleMicrosoftAuthInitialize();
    } else if (esp === 8) {
      handleZohoAuth();
    } else if (isOAuthMailboxEsp(esp)) {
      handleGoogleAuth();
    }
    setOpen(false);
  };

  const modalHeaderData = {
    heading: {
      id: STRINGS.CONNECT,
      label: STRINGS.CONNECT_MAILBOX_TITLE,
    },
  };

  const modalBodyData = (
    <div className={classes.modalBody}>
      <Box className={classes.content}>
        <TypographyInline
          size={"sm"}
          color={GREY.QUATINARY}
          fontWeight={fontWeight.REGULAR}
          label={`${mailbox?.email || providerLabel} ${STRINGS.CONNECT_MAILBOX_DESC}`}
        />
        <TypographyInline
          size={"sm"}
          color={GREY.QUATINARY}
          fontWeight={fontWeight.REGULAR}
          label={STRINGS.CONNECT_MAILBOX_KEEPS_DATA}
        />
      </Box>
    </div>
  );

  const modalFooterRightData = (
    <Box className={classes.footer}>
      <Button
        label={STRINGS.CANCEL}
        variant={"ghost"}
        size={"sm36"}
        onClick={() => setOpen(false)}
      />
      <Button
        label={STRINGS.CONNECT}
        variant={"primary"}
        size={"sm36"}
        onClick={startConnect}
      />
    </Box>
  );

  return (
    <CustomModal
      close={() => setOpen(false)}
      open={open}
      header={modalHeaderData}
      children={modalBodyData}
      footer={{ left: <Box></Box>, right: modalFooterRightData }}
    />
  );
};

export default ReconnectModal;
